import config from '@project/config';

const eventShowcaseBaseUrl = `${config.apiUrl}/showcase_categories`;

export default {
  getShowcaseCategoriesUrl: () => `${eventShowcaseBaseUrl}`,
  getShowcaseCategoryUrl: (id: string) => `${eventShowcaseBaseUrl}/${id}`,
  getShowcaseUrl: (id: string) => `${config.apiUrl}/showcases/${id}`,
};
